<template>
  <div id="tugendhatEdit">
    <app-menu></app-menu>
    <div class="col-lg-10 offset-lg-1">
      <h3 class="text-center pb-lg-4">Light Up Tugendhat</h3>
      <div class="form-check visibility-toggle">
        <input id="tugendhat-visible" class="form-check-input" type="checkbox" v-model="page.visible">
        <label class="form-check-label" for="tugendhat-visible">
          Zveřejnit stránku a odkaz v menu
        </label>
      </div>
      <div class="row pt-lg-5">
        <div class="col-lg-6">
          <h4 class="text-center">Čeština</h4>
          <div class="form-group">
            <label>Nadpis:</label>
            <input type="text" class="form-control" v-model="page.title.cs" placeholder="Název stránky">
          </div>
          <div class="form-group">
            <label>Text:</label>
            <html-editor
                v-if="dataLoaded"
                ref="editorCs"
                v-model="page.text.cs"
                :customToolbar="editorToolbar"
            ></html-editor>
            <textarea v-if="isDevActive" class="form-control" v-model="page.text.cs" rows="3"></textarea>
          </div>
        </div>
        <div class="col-lg-6">
          <h4 class="text-center">Angličtina</h4>
          <div class="form-group">
            <label>Nadpis:</label>
            <input type="text" class="form-control" v-model="page.title.en" placeholder="Název stránky">
          </div>
          <div class="form-group">
            <label>Text:</label>
            <html-editor
                v-if="dataLoaded"
                ref="editorEn"
                v-model="page.text.en"
                :customToolbar="editorToolbar"
            ></html-editor>
            <textarea v-if="isDevActive" class="form-control" v-model="page.text.en" rows="3"></textarea>
          </div>
        </div>
      </div>
      <div class="row pt-lg-4">
        <div class="col-lg-6">
          <h5 class="text-center">Foto – náhled:</h5>
          <div class="form-group pt-lg-4">
            <input type="file" class="form-control-file pt-lg-4" accept="image/jpeg" @change="selectMainImage"
                   aria-describedby="fileHelp">
            <small class="form-text text-muted"></small>
          </div>
          <a v-if="mainImage.length > 0" class="closeButton" type="button" v-on:click="deleteMainPhoto()">✕</a>
          <img v-if="mainImage.length > 0" class="img-fluid" width="50%" :src="mainImage">
        </div>
        <div class="col-lg-6">
          <h5 class="text-center">Foto – ostatní:</h5>
          <div class="form-group pt-lg-4">
            <input type="file" class="form-control-file pt-lg-4" accept="image/jpeg" @change="selectImage"
                   aria-describedby="fileHelp">
            <small class="form-text text-muted"></small>
          </div>
          <div v-for="(image, index) in images" v-bind:key="index">
            <a class="closeButton" type="button" v-on:click="deletePhoto(image)" :id="index">✕</a>
            <img class="img-fluid pb-lg-2" width="50%" :src="image">
          </div>
        </div>
      </div>
      <div class="text-center pt-lg-4">
        <send-button
            ref="saveBtn"
            :send="save"
            text="Uložit Tugendhat"
            :response="error"
        />
      </div>
    </div>
    <error-modal :message="error"/>
  </div>
</template>

<script>
import AdminMenu from "@/components/admin/AdminMenu";
import axios from "@/api/axiom-instance";
import config from "@/config";
import ErrorModal from "@/components/admin/ErrorModal";
import SendButton from "@/components/admin/SendButton";
import {VueEditor} from "vue2-editor";
import {EDITOR_TOOLBAR, setupEditorToolbars} from "@/editor/quillSetup";

export default {
  name: "TugendhatEdit",
  components: {
    'app-menu': AdminMenu,
    'error-modal': ErrorModal,
    'send-button': SendButton,
    'html-editor': VueEditor
  },
  computed: {
    isDevActive: function () {
      return localStorage.getItem('dev') === 'true'
    }
  },
  data() {
    return {
      page: { id: null, title: { cs: '', en: '' }, text: { cs: '', en: '' }, visible: false },
      mainImage: '',
      images: [],
      error: null,
      dataLoaded: false,
      editorToolbar: EDITOR_TOOLBAR
    }
  },
  watch: {
    dataLoaded(val) {
      if (val) {
        this.$nextTick(() => { setupEditorToolbars(this.$refs); });
      }
    }
  },
  created() {
    this.load();
  },
  methods: {
    load: function () {
      axios
        .get("/tugendhat/admin")
        .then((success) => {
          if (success.data) {
            this.page = success.data;
            this.mainImage = config.API_URL + '/image?type=tugendhat-main&name=tugendhat';
          }
          this.dataLoaded = true;
        }).catch(() => {
          this.dataLoaded = true;
        });
      axios
        .get("/image/list", { params: { type: "tugendhat-others/tugendhat" } })
        .then((success) => {
          this.images = success.data.map(it => it.src);
        }).catch(error => this.error = error);
    },

    save: function () {
      axios.post("/tugendhat", this.page).then((success) => {
        axios.post("/image", { name: 'tugendhat', type: 'tugendhat-main', data: this.mainImage }).then(() => {
          axios.post("/image/bulk", { name: 'tugendhat', type: 'tugendhat-others', data: this.images }).then(() => {
            this.page = success.data;
            this.$refs.saveBtn.enable();
          }).catch(error => this.error = error);
        }).catch(error => this.error = error);
      }).catch(error => this.error = error);
    },

    selectMainImage: function (e) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = e => { this.mainImage = e.target.result; };
    },

    selectImage: function (e) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = e => { this.images.push(e.target.result); };
    },

    deleteMainPhoto: function () {
      this.mainImage = '';
    },

    deletePhoto: function (value) {
      this.images = this.images.filter(it => it !== value);
    }
  }
}
</script>

<style scoped>
#tugendhatEdit {
  min-height: 100vh;
  padding-bottom: 4em;
  overflow: hidden;
}

.closeButton {
  position: absolute;
  background-color: black;
  color: white;
  padding: 3px 7px;
  cursor: pointer;
}

.visibility-toggle {
  font-family: "Transcript Mono";
  font-size: 1.1em;
}
</style>

